import { usePermissions } from '#/store/ducks/permissions'

/** Indica que o usuário tem permissão para usar o chat da VIC na fazenda atual */
export function useCanUseVicChat(): boolean {
  const permissions = usePermissions()
  return Boolean(permissions.farm.use_vic_gpt_cowmed || permissions.farm.use_vic_gpt)
}
